import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { CurrencyModel } from "../../../businessFoundation/Primitives/CurrencyManage/CurrencyModel";
import { TextField } from "@episerver/ui-framework";
const CurrencyField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, setValue, errors } = props;
    const validationData = property.validationData as CurrencyModel;

    useEffect(() => {
        if (property.value) {
            setValue(`extendedProperties[${index}].value`, Number(property.value).toFixed(2));
        }
    }, []);

    return (
        <Controller
            name={`extendedProperties[${index}].value`}
            control={control}
            rules={{
                required: {
                    value: !property.isNullable,
                    message: `${property.friendlyName} is required`,
                },
                pattern: {
                    value: /^-?(\d{1,}|\d{0,}\.\d{1,2})$/,
                    message: "Value is invalid.",
                },
                min: {
                    value: validationData.allowNegative ? -922337203685477 : 0,
                    message: `${property.friendlyName} is invalid`,
                },
                max: {
                    value: 922337203685477,
                    message: `${property.friendlyName} is invalid`,
                },
            }}
            render={({ field: { onChange, value } }) => (
                <TextField
                    id={`extendedProperties[${index}].value`}
                    type="text"
                    outlined
                    label={property.friendlyName}
                    helperText={errors.extendedProperties ? errors.extendedProperties[index]?.value?.message ?? property.description : property.description}
                    invalid={errors.extendedProperties && errors.extendedProperties[index]?.value ? true : false}
                    defaultValue={value != null ? Number(value).toFixed(2) : ""}
                    onChange={onChange}
                />
            )}
        />
    );
};

export default CurrencyField;
